var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ios_share_black_24dp",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5 L14.58,6.42 L12.99,4.83 L12.99,16 L11.01,16 L11.01,4.83 L9.42,6.42 L8,5 L12,1 L16,5 Z M20,10 L20,21 C20,22.1 19.1,23 18,23 L6,23 C4.89,23 4,22.1 4,21 L4,10 C4,8.89 4.89,8 6,8 L9,8 L9,10 L6,10 L6,21 L18,21 L18,10 L15,10 L15,8 L18,8 C19.1,8 20,8.89 20,10 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.2eb8ea6a2f69ef6257eb2abb2578b1d9.svg";
export { ForwardRef as ReactComponent };